import axios from "axios";

const request = axios.create({
  // baseURL: 'http://127.0.0.1:5000',
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
});

request.interceptors.request.use(config => {
  return config;
}, error => {
  return Promise.reject(error)
});

request.interceptors.response.use(response => {
  return response.data;
}, error => {
  return Promise.reject(error.response?.data || { message: '请求失败' });
});

export default request;